import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../../../assets/css/dashboard.css";
import * as CONST from "../../../component/config/Constant";
import { AuthContext } from "../../../component/context/AuthContext";
import DivSpinner from "../../../component/utilities/Spinner";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import moment from "moment";
import Chatbot from "../../../component/chatbot/Chatbot";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Moment from "moment";
import { FiCalendar, FiClock, FiUsers, FiGift, FiSun, FiUserPlus, FiPhone, FiMail, FiChevronRight, FiCheck, FiX, FiMinus, FiMessageSquare, FiBox, FiCreditCard, FiBell } from "react-icons/fi";

function Dashboard() {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [deptStats, setDeptStats] = useState("");
  const [testimonialData, setTestimonialData] = useState("");
  const [dashboadDetails, setDashboadDetails] = useState("");
  const [upcomingLeave, setUpcomingLeave] = useState("");
  const [upcomingEvent, setUpcomingEvent] = useState("");
  const [leaveRemainingCount, setLeaveRemainingCount] = useState("0");
  const [eventRemainingCount, setEventRemainingCount] = useState("0");
  const [headUserLists, setHeadUserLists] = useState("");
  const [profilePercent, setProfilePercent] = useState("0");
  const currentDate = new Date();
  const [myLeaveLisiting, setMyLeaveLisiting] = useState("");
  const [myCompoffLisiting, setMyCompoffLisiting] = useState("");
  const [empCompOffLisiting, setEmpCompOffLisiting] = useState("");
  const [upcomingStats, setUpcomingStats] = useState("");
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [ticketStats, setTicketStats] = useState({ open: 0, inProgress: 0, total: 0 });
  const [assetStats, setAssetStats] = useState({ pending: 0, allocated: 0 });
  const [subscriptionStats, setSubscriptionStats] = useState({ pending: 0, active: 0 });
  const [pendingApprovals, setPendingApprovals] = useState(0);

  const profileList = [
    { id: "1", name: "Personal Information", link: "account/profile" },
    { id: "2", name: "Change Password", link: "account/profile" },
    { id: "3", name: "Guardian Information", link: "account/profile" },
    { id: "4", name: "Education Information", link: "account/profile" },
    { id: "5", name: "Document Information", link: "account/profile" },
    { id: "6", name: "Experience Information", link: "account/profile" },
    { id: "7", name: "Social Links", link: "account/profile" },
    { id: "8", name: "My Roles & responsiblity", link: "account/roles" },
  ];

  const [dataSort] = useState({ order: "desc", order_by: "id" });
  const [searchParam] = useState({ srchName: "", srchStatus: "", srchLeaveDate: "", srchLeaveType: "" });
  const toggleText = (rowId) => setExpandedRowId((prev) => (prev === rowId ? null : rowId));

  let totalCount = 0, dptPercentage = 0, isToken = "", authUserName = "", is_head = 0, is_admin = 0, photo_path = "", userId = 0;
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token || "";
    authUserName = (authUserData[0].first_name || "") + (authUserData[0].last_name ? " " + authUserData[0].last_name : "");
    photo_path = authUserData[0].profile_photo_path || "";
    is_head = authUserData[0].is_head || 0;
    is_admin = authUserData[0].is_admin || 0;
    userId = authUserData[0].user_id || 0;
  }
  const profileImage = CONST.HOST + photo_path;

  // All fetch functions remain identical
  async function fetchDepartmentCounts() { await axios.get(CONST.CNT_DEPARTMENT, { headers: { Authorization: `Basic ${isToken}` } }).then((r) => { if (r.data.status === "success") setDeptStats(r.data.data); }).catch(() => {}); }
  async function fetchTestimonialsData() { await axios.post(CONST.ADMIN_TESTIMONIAL_LIST, { limit: 5, page_number: 1, search_input: "", sort: "" }, { headers: { Authorization: `Basic ${isToken}` } }).then((r) => { if (r.data.status === "success") setTestimonialData(r.data.data); }).catch(() => {}); }
  async function fetchheadUserLists() { await axios.get(CONST.GET_HEAD_USER, { headers: { Authorization: `Basic ${isToken}` } }).then((r) => { if (r.data.status == "success") setHeadUserLists(r.data.data); }).catch(() => {}); }
  async function fetchDashboardDetails() {
    await axios.post(CONST.DASHBOARD_DATA, { is_head, is_admin }, { headers: { Authorization: `Basic ${isToken}` } }).then((r) => {
      if (r.data.status === "success") {
        setDashboadDetails(r.data.data[0]);
        if (r.data.data[0].upcomingLeavesCount?.leave_from_date?.length > 0) { const d = new Date(r.data.data[0].upcomingLeavesCount.leave_from_date); setLeaveRemainingCount(Math.ceil(Math.abs(d - currentDate) / 86400000)); }
        if (r.data.data[0].upcomingEventsCount[0]?.event_date?.length > 0) { const d = new Date(r.data.data[0].upcomingEventsCount[0].event_date); setEventRemainingCount(Math.ceil(Math.abs(d - currentDate) / 86400000)); }
      }
    }).catch(() => {});
  }
  async function fetchMyLeavesDetails() { await axios.post(CONST.GET_USER_LEAVES, { id: userId, limit: 5, year: moment().format('YYYY'), page_number: 1 }, { headers: { Authorization: `Basic ${isToken}` } }).then((r) => { if (r.data.status === "success") setMyLeaveLisiting(r.data.data); else setMyLeaveLisiting(""); }).catch(() => {}); }
  async function fetchMyCompOffDetails() { await axios.post(CONST.COMP_OFF_GET_MY, { id: userId, limit: 5, year: "2023", page_number: 1, month: "", sort: dataSort, search_input: searchParam }, { headers: { Authorization: `Basic ${isToken}` } }).then((r) => { if (r.data.status === "success") setMyCompoffLisiting(r.data.data); else setMyCompoffLisiting(""); }).catch(() => {}); }
  async function fetchEmployeeCompOffDetails() { await axios.post(CONST.COMP_OFF_GET_TOCC, { user_id: userId, limit: 5, year: "2023", page_number: 1, month: "", sort: dataSort, search_input: searchParam, is_admin, is_head }, { headers: { Authorization: `Basic ${isToken}` } }).then((r) => { if (r.data.status === "success") setEmpCompOffLisiting(r.data.data); else setEmpCompOffLisiting(""); }).catch(() => {}); }
  async function fetchFeildsInfo() { await axios({ method: "Post", url: CONST.USER_PROFILE_INFO, headers: { Authorization: `Bearer ${isToken}` } }).then((r) => { if (r.data.status === "success") setProfilePercent(r.data.data); }).catch(() => {}); }
  async function fetchUpcomingDetails() { await axios.get(CONST.UPCOMING_INFO, { headers: { Authorization: `Basic ${isToken}` } }).then((r) => { if (r.data.status === "success") setUpcomingStats(r.data.data); }).catch(() => {}); }

  async function fetchTicketStats() {
    try {
      const r = await axios.post(CONST.GET_TICKET_LIST, {
        user_id: userId, sort: { order_by: "id", order: "desc" }, page_number: 1, limit: 10000,
        is_head: 0, srchDate: '', username: '', departmentName: '', ticketId: '', owner_only: 1
      }, { headers: { Authorization: `Basic ${isToken}` } });
      if (r.data.status === "success") {
        const tickets = (r.data.data || []).filter(t =>
          (t.createdByData && t.createdByData.id == userId) ||
          (t.createdForData && t.createdForData.id == userId)
        );
        setTicketStats({
          total: tickets.length,
          open: tickets.filter(t => t.status === "0").length,
          inProgress: tickets.filter(t => t.status === "1").length,
        });
      }
    } catch (e) {}
  }

  async function fetchAssetStats() {
    try {
      const r = await axios.post(CONST.GET_ASSETS_LIST, {
        user_id: userId, limit: 1000, page_number: 1,
        search_input: { srchAssetName: "", srchAssetStatus: "" },
        sort: { order: "desc", order_by: "id" }
      }, { headers: { Authorization: `Bearer ${isToken}` } });
      if (r.data.status === "success" && r.data.stats) {
        setAssetStats({ pending: r.data.stats.pending || 0, allocated: r.data.stats.allocated || 0 });
      }
    } catch (e) {}
  }

  async function fetchSubscriptionStats() {
    try {
      const r = await axios.get(CONST.GET_MY_SUBSCRIPTIONS, { headers: { Authorization: `Bearer ${isToken}` } });
      if (r.data.status === "success") {
        const subs = r.data.data || [];
        setSubscriptionStats({
          pending: subs.filter(s => s.status === "pending").length,
          active: subs.filter(s => s.status === "active" || s.status === "approved").length,
        });
      }
    } catch (e) {}
  }

  async function fetchNotificationCounts() {
    if (is_head == '1' || is_admin == '1') {
      try {
        const r = await axios.post(CONST.GET_NOTIFICATION_COUNTS, {
          user_id: userId, is_admin, is_head, department_id: authUserData?.[0]?.department_id || ''
        }, { headers: { Authorization: `Bearer ${isToken}` } });
        if (r.data.status === 'success') setPendingApprovals(r.data.data.pending_approvals || 0);
      } catch (e) {}
    }
  }

  useEffect(() => {
    fetchDepartmentCounts(); fetchTestimonialsData(); fetchDashboardDetails();
    fetchheadUserLists(); fetchFeildsInfo(); fetchMyLeavesDetails();
    fetchMyCompOffDetails(); fetchEmployeeCompOffDetails(); fetchUpcomingDetails();
    fetchTicketStats(); fetchAssetStats(); fetchSubscriptionStats(); fetchNotificationCounts();
  }, []);

  const getGreeting = () => {
    const h = new Date().getHours();
    if (h < 12) return "Good Morning";
    if (h < 17) return "Good Afternoon";
    return "Good Evening";
  };

  const StatusBadge = ({ status }) => {
    const map = { 1: { label: "Approved", cls: "db-badge-success" }, 2: { label: "Rejected", cls: "db-badge-danger" }, 3: { label: "Cancelled", cls: "db-badge-muted" } };
    const s = map[status] || { label: "Pending", cls: "db-badge-warning" };
    return <span className={`db-status-badge ${s.cls}`}>{s.label}</span>;
  };

  const UserAvatar = ({ user, size = 40 }) => {
    if (!user) return null;
    if (user.profile_photo_path) return <img src={CONST.HOST + user.profile_photo_path} alt="" width={size} className="db-avatar-img" />;
    const initials = (user.first_name?.[0] || "") + (user.last_name?.[0] || user.name?.[1] || "");
    return <span className="db-avatar-initials">{initials}</span>;
  };

  const LeaveTable = ({ data, type }) => {
    if (!data || data === "") return <div className="db-empty">No {type} Found</div>;
    return (
      <div className="table-responsive">
        <table className="table db-table">
          <thead><tr><th>User</th><th>Reason</th><th>Date</th><th>Applied</th><th>Status</th></tr></thead>
          <tbody>
            {data.map((leave, i) => {
              const user = type.includes("Comp") && leave.compoffAddedBy ? leave.compoffAddedBy : (leave.e_compoff?.compoffAddedBy || leave.user);
              const reason = leave.e_compoff?.reason || leave.reason || "";
              const dateField = leave.leave_from_date || leave.compoff_date || "";
              const appliedField = leave.created_at || leave.compoff_date || leave.leave_applied_date || "";
              const status = leave.e_compoff?.status || leave.status;
              return (
                <tr key={i}>
                  <td>
                    <div className="db-user-cell">
                      <UserAvatar user={user} />
                      <div>
                        <div className="db-user-name">{user?.first_name} {user?.last_name}</div>
                        {user?.department?.name && <div className="db-user-dept">{user.department.name}</div>}
                      </div>
                    </div>
                  </td>
                  <td>
                    {reason.length > 50 && expandedRowId !== leave.id
                      ? <><span dangerouslySetInnerHTML={{ __html: reason.slice(0, 50) + "..." }} /> <button className="db-read-more" onClick={() => toggleText(leave.id)}>More</button></>
                      : <><span dangerouslySetInnerHTML={{ __html: reason }} /> {reason.length > 50 && <button className="db-read-more" onClick={() => toggleText(leave.id)}>Less</button>}</>
                    }
                  </td>
                  <td className="text-nowrap">{Moment(dateField).format("DD MMM YYYY")}</td>
                  <td className="text-nowrap">{Moment(appliedField).format("DD MMM YYYY")}</td>
                  <td><StatusBadge status={status} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <div className="db-page">
        {/* Hero Header */}
        <div className="db-header">
          <div className="container">
            <div className="db-header-inner">
              <div>
                <span className="db-header-greeting">{getGreeting()}</span>
                <h1 className="db-header-name">{authUserName}</h1>
              </div>
              <div className="db-header-date">
                <FiCalendar /> {moment().format("dddd, DD MMMM YYYY")}
              </div>
            </div>
          </div>
        </div>

        <div className="db-body">
          <div className="container">
            {/* Stat Cards */}
            <div className="row db-stats-row">
              {[
                { label: "Total Leaves", value: dashboadDetails.allocatedLeaves || 0, color: "#1167e8", icon: <FiCalendar /> },
                { label: "Leaves Used", value: dashboadDetails.leavesUsedCount || 0, color: "#c2410c", icon: <FiMinus /> },
                { label: "Balance Leaves", value: dashboadDetails.pendingLeaves || 0, color: "#059669", icon: <FiCheck /> },
                { label: "Open Requests", value: ticketStats.open, color: "#b45309", icon: <FiMessageSquare /> },
                ...(pendingApprovals > 0 ? [{ label: "Pending Approvals", value: pendingApprovals, color: "#dc2626", icon: <FiBell />, link: CONST.ADMIN_PRE + "requests/all" }] : []),
                { label: "My Assets", value: assetStats.allocated, color: "#7c3aed", icon: <FiBox /> },
                { label: "Subscriptions", value: subscriptionStats.active, color: "#0891b2", icon: <FiCreditCard /> },
              ].map((stat, i) => (
                <div className="col-md-4 col-xl-2 mb-3" key={i}>
                  <div className="db-stat-card">
                    <div className="db-stat-icon" style={{ background: stat.color + "15", color: stat.color }}>{stat.icon}</div>
                    <div className="db-stat-info">
                      <div className="db-stat-value">{stat.value}</div>
                      <div className="db-stat-label">{stat.label}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="row">
              {/* Left Column */}
              <div className="col-lg-4 mb-4">
                {/* Upcoming Activity */}
                <div className="db-card">
                  <div className="db-card-header"><h6>Upcoming Activity</h6></div>
                  <div className="db-card-body db-activity-list">
                    {upcomingStats ? (
                      <>
                        {/* On Leave Today */}
                        {upcomingStats[0].onLeaveToday?.map((s, i) => (
                          <div className="db-activity-item" key={`l${i}`}>
                            <div className="db-activity-icon db-activity-leave"><FiMinus /></div>
                            <div className="db-activity-content">
                              <div className="db-activity-text"><strong>{s.user?.first_name} {s.user?.last_name}</strong> is on leave today</div>
                              <div className="db-activity-sub">{s.status === 0 ? 'Pending' : 'Approved'}</div>
                            </div>
                          </div>
                        ))}
                        {/* Birthdays this month */}
                        {upcomingStats[0].todayBirthdayUsers.map((s, i) => (
                          <div className="db-activity-item" key={`b${i}`}>
                            <div className="db-activity-icon db-activity-birthday"><FiGift /></div>
                            <div className="db-activity-content">
                              <div className="db-activity-text">{Number(s.is_today) === 1 ? <>It's <strong>{s.first_name} {s.last_name}</strong>'s birthday!</> : <><strong>{s.first_name} {s.last_name}</strong>'s birthday</>}</div>
                              <div className="db-activity-sub">{Number(s.is_today) === 1 ? 'Today' : s.birth_date_display}</div>
                            </div>
                          </div>
                        ))}
                        {/* Upcoming Holidays */}
                        {upcomingStats[0].holidayDetails.map((s, i) => (
                          <div className="db-activity-item" key={`h${i}`}>
                            <div className="db-activity-icon db-activity-holiday"><FiSun /></div>
                            <div className="db-activity-content">
                              <div className="db-activity-text"><strong>{s.holiday_name}</strong> Holiday</div>
                              <div className="db-activity-sub">{s.holiday_date}</div>
                            </div>
                          </div>
                        ))}
                        {/* Upcoming Events */}
                        {upcomingStats[0].upcomingEventDetails.map((e, i) => (
                          <div className="db-activity-item" key={`e${i}`}>
                            <div className="db-activity-icon db-activity-event"><FiCalendar /></div>
                            <div className="db-activity-content">
                              <div className="db-activity-text">Upcoming event <strong>{e.title}</strong></div>
                              <div className="db-activity-sub">{e.event_date}</div>
                            </div>
                          </div>
                        ))}
                        {/* New Joinees */}
                        {upcomingStats[0].newJoineeUsers.map((s, i) => (
                          <div className="db-activity-item" key={`n${i}`}>
                            <div className="db-activity-icon db-activity-joinee"><FiUserPlus /></div>
                            <div className="db-activity-content">
                              <div className="db-activity-text">New joinee <strong>{s.first_name} {s.last_name}</strong> from <strong>{s.department?.name}</strong></div>
                              <div className="db-activity-sub">{s.date_of_joining}</div>
                            </div>
                          </div>
                        ))}
                      </>
                    ) : <div className="db-empty">No upcoming activity</div>}
                  </div>
                </div>

                {/* Profile Completion */}
                <div className="db-card mt-3">
                  <div className="db-card-header"><h6>Profile Completion</h6></div>
                  <div className="db-card-body">
                    <div className="db-profile-ring">
                      <CircularProgressbarWithChildren value={profilePercent} styles={{ path: { stroke: '#1167e8' }, trail: { stroke: '#e2e8f0' } }}>
                        <img style={{ width: 50, borderRadius: '50%' }} src={profileImage} alt="profile" />
                        <div className="db-profile-percent">{profilePercent}%</div>
                      </CircularProgressbarWithChildren>
                    </div>
                    <div className="db-profile-links">
                      {profileList.map((item, i) => (
                        <Link to={CONST.ADMIN_PRE + item.link} className="db-profile-link" key={i}>
                          {item.name} <FiChevronRight size={14} />
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="col-lg-8 mb-4">
                {/* Department Heads */}
                <div className="db-card mb-3">
                  <div className="db-card-header"><h6>Department Heads</h6></div>
                  <div className="db-card-body">
                    <div className="db-heads-grid">
                      {headUserLists ? headUserLists.map((h, i) => {
                        const initials = h.name?.split(" ").map(n => n[0]).join("") || "";
                        return (
                          <div className="db-head-card" key={i}>
                            <div className="db-head-avatar">
                              {h.profile_photo_path ? <img src={CONST.HOST + h.profile_photo_path} alt="" /> : <span>{initials}</span>}
                            </div>
                            <div className="db-head-info">
                              <div className="db-head-name">{h.name}</div>
                              <div className="db-head-dept">{h.department} &middot; {h.designation}</div>
                              {h.phone_number && <a href={`tel:${h.phone_number}`} className="db-head-contact"><FiPhone size={12} /> {h.phone_number}</a>}
                              {h.email && <a href={`mailto:${h.email}`} className="db-head-contact"><FiMail size={12} /> {h.email}</a>}
                            </div>
                          </div>
                        );
                      }) : <DivSpinner size="sm" color="primary" />}
                    </div>
                  </div>
                </div>

                {/* Leave/Comp-Off Tabs */}
                <div className="db-card">
                  <Tabs>
                    <TabList className="db-tab-list">
                      {(is_admin == "1" || is_head == "1") && <><Tab className="db-tab">Employee Leaves</Tab><Tab className="db-tab">Employee Comp-Off</Tab></>}
                      <Tab className="db-tab">My Leaves</Tab>
                      <Tab className="db-tab">My Comp-Off</Tab>
                    </TabList>
                    {(is_admin == "1" || is_head == "1") && (
                      <>
                        <TabPanel><LeaveTable data={dashboadDetails.leavedTableListing} type="Employee Leaves" /></TabPanel>
                        <TabPanel><LeaveTable data={empCompOffLisiting} type="Employee Comp-Off" /></TabPanel>
                      </>
                    )}
                    <TabPanel><LeaveTable data={myLeaveLisiting} type="My Leaves" /></TabPanel>
                    <TabPanel><LeaveTable data={myCompoffLisiting} type="My Comp-Off" /></TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>

            {/* Testimonials */}
            <div className="db-card mb-4">
              <div className="db-card-header"><h6>Latest Testimonials</h6></div>
              <div className="db-card-body">
                {testimonialData && testimonialData.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table db-table">
                      <thead><tr><th>User</th><th>Testimonial</th><th>Added By</th><th>Date</th><th>Status</th></tr></thead>
                      <tbody>
                        {testimonialData.map((t, i) => t.status === 1 ? (
                          <tr key={i}>
                            <td><div className="db-user-cell"><UserAvatar user={t.user} /><div><div className="db-user-name">{t.user?.first_name} {t.user?.last_name}</div><div className="db-user-dept">{t.user?.department?.name}</div></div></div></td>
                            <td><span className="db-testimonial-text">{t.description}</span></td>
                            <td><div className="db-user-cell"><UserAvatar user={t.added_by_admin} /><div><div className="db-user-name">{t.added_by_admin?.first_name} {t.added_by_admin?.last_name}</div></div></div></td>
                            <td className="text-nowrap">{Moment(t.created_at).format("DD MMM YYYY")}</td>
                            <td><span className="db-status-badge db-badge-success">Active</span></td>
                          </tr>
                        ) : null)}
                      </tbody>
                    </table>
                  </div>
                ) : <div className="db-empty">No testimonials found</div>}
              </div>
            </div>
          </div>
        </div>
        <Chatbot Query="CHATBOT_QUERY" />
      </div>
    </>
  );
}

export default Dashboard;
